import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
Flickity.setJQuery($);
jQueryBridget('flickity', Flickity, $);

$('.js-reviews').each(function (index, reviews) {
  const $reviews = $(reviews);
  const $reviewsList = $reviews.find('.js-reviews-list');

  $reviewsList.flickity({
    adaptiveHeight: true,
    autoPlay: 10000,
    imagesLoaded: true,
    lazyLoad: true,
    contain: true,
    draggable: true,
    pageDots: false,
    wrapAround: true,
    arrowShape:
      'M20.81 50l4.781 5.006L68.786 100l10.405-10.011-38.414-39.99 38.414-39.988L68.786 0 25.591 44.994 20.81 50z',
  });

  $reviewsList
    .find('.flickity-prev-next-button.previous')
    .addClass('reviews__control is-previous');
  $reviewsList
    .find('.flickity-prev-next-button.next')
    .addClass('reviews__control is-next');
});
